export function formatUnixTimestamp(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000) // Convert seconds to milliseconds

  // Format options for US users
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }

  return new Intl.DateTimeFormat("en-US", options).format(date)
}

// Sort Utility
export const sortData = (data, sortConfig) => {
  if (sortConfig?.key) {
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key]?.toString().toLowerCase() || ""
      const bValue = b[sortConfig.key]?.toString().toLowerCase() || ""
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1
      return 0
    })
  }
  return data
}

// Pagination Utility
export const paginateData = (data, currentPage, itemsPerPage) => {
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = currentPage * itemsPerPage
  return data.slice(startIndex, endIndex)
}

export function validateFaxNumber(faxNumber) {
  const cleanedFaxNumber = faxNumber.replace(/[^\d]/g, "")

  const regex = /^(1[2-9][0-9]{9}|[2-9][0-9]{9})$/

  if (regex.test(cleanedFaxNumber)) {
    return true
  }

  return false
}

export function Loader() {
  return (
    // <span className="emoji-loader">
    //    ⏳
    //   </span>
    <div className="loading-container">
      <div className="loading-message">Loading...</div>
    </div>
  )
}

export const downloadPdfFromBase64 = (
  base64String,
  filename = "document.pdf",
) => {
  try {
    // Decode Base64 to binary
    const byteCharacters = atob(base64String)
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i))
    const byteArray = new Uint8Array(byteNumbers)

    // Create a Blob and generate URL
    const blob = new Blob([byteArray], { type: "application/pdf" })
    const url = URL.createObjectURL(blob)

    // Create a temporary anchor to trigger download
    const link = document.createElement("a")
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()

    // Cleanup
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  } catch (error) {
    console.error("Error downloading PDF:", error)
  }
}
